import React, { createContext, useContext, useState } from 'react'

type SearchContextType = {
  contentMatchIds: Set<string>
  setContentMatchIds: React.Dispatch<React.SetStateAction<Set<string>>>
}

export const SearchContext = createContext<SearchContextType>({
  contentMatchIds: new Set(),
  setContentMatchIds: () => null,
})

export const SearchProvider = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const [contentMatchIds, setContentMatchIds] = useState<Set<string>>(new Set())

  return (
    <SearchContext.Provider
      value={{
        contentMatchIds,
        setContentMatchIds,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}

export const useSearchContext = (): SearchContextType =>
  useContext(SearchContext)
